<template>
  <b-navbar sticky>
    <b-navbar-nav>
      <img
        class="arrow mt-4 ml-md-4 ml-0 mr-3"
        :class="!sidebarActive ? 'arrow--active' : ''"
        :src="asset('imgs/icons/double-arrow-black.svg')"
        alt="sidebar-arrow"
        width="14"
        height="12"
        @click="openSideBar"
      />
      <router-link to="/">
        <img
          class="mt-3 mb-2 nav-logo"
          :src="asset('imgs/zuulOS.png')"
          alt="Logo"
          width="100"
          height="23"
        />
      </router-link>
    </b-navbar-nav>
    <b-navbar-nav v-if="$route.path === '/dispatch'" class="mx-auto">
      <h1 v-if="time" class="mb-0 text-black">
        {{ time.toLocaleTimeString('en-US') }}
      </h1>
    </b-navbar-nav>
    <b-navbar-nav :class="[$route.path === '/dispatch' ? '' : 'ml-auto']">
      <b-nav-item-dropdown right>
        <!-- Using 'button-content' slot -->
        <template #button-content>
          <img
            :src="asset('imgs/icons/person.svg')"
            alt="person"
            width="22"
            height="22"
          />
        </template>
        <h2>{{ firstName }} {{ lastName }}</h2>
        <p>{{ email }}</p>
        <hr class="mb-0" />
        <b-dropdown-item @click="toAccount">
          <img
            :src="asset('imgs/icons/person.svg')"
            alt="person"
            width="15"
            height="15"
          />
          My account
        </b-dropdown-item>
        <b-dropdown-item @click="onSignOut">
          <img
            :src="asset('imgs/icons/logout.png')"
            alt="logout"
            width="15"
            height="15"
          />
          Log out
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isSidebarOpen: false,
      time: new Date(),
    };
  },
  computed: {
    ...mapGetters('session', [
      'firstName',
      'lastName',
      'email',
      'sidebarActive',
    ]),
  },
  mounted() {
    // in case if route doesn't match '/dispatch'
    if (this.$route.path === '/dispatch') {
      setInterval(this.setTime, 1000);
    }
  },
  methods: {
    setTime() {
      this.time = new Date();
    },
    openSideBar() {
      this.$store.dispatch('session/toggleSidebar');
    },
    toAccount() {
      if (this.$route.name !== 'account') {
        this.$router.push({ name: 'account' });
      }
    },
    onSignOut() {
      this.$store.dispatch('session/loggedOut');
    },
  },
};
</script>
